import { useEffect, useState } from 'react';
import SidePanel from '../../components/SidePanel';
import Dropdown from '../../components/receptura/Dropdown';

export default function OtevritFlekModal({ isDark, onClose, onSaved }) {
    const [fleky, setFleky] = useState([]);
    const [zamestnanci, setZamestnanci] = useState([]);
    const [pokladnaId, setPokladnaId] = useState('');
    const [zamestnanecId, setZamestnanecId] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [isMobile] = useState(() => typeof window !== 'undefined' && window.innerWidth < 768);
    const token = document.querySelector('meta[name="csrf-token"]')?.content;

    useEffect(() => {
        Promise.all([
            fetch('/api/finance/pokladna/prehled', { credentials: 'same-origin' }).then(r => r.json()),
            fetch('/api/zamestnanci', { credentials: 'same-origin' }).then(r => r.ok ? r.json() : []),
        ]).then(([p, z]) => {
            // jen rozvozové fleky bez aktivní smeny — hlavní pokladna se otevírá
            // automaticky systémem (drží ji aktuální manažer směny)
            setFleky((p?.fleky ?? []).filter(f => !f.aktivni_smena && f.typ !== 'bistro_hlavni'));
            setZamestnanci(Array.isArray(z) ? z : (z?.data ?? []));
        }).catch(console.error);
    }, []);

    const handleSubmit = async () => {
        if (!pokladnaId || !zamestnanecId) {
            alert('Vyber flek a zaměstnance.');
            return;
        }
        setSubmitting(true);
        try {
            const r = await fetch('/api/finance/pokladna/smeny', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': token },
                credentials: 'same-origin',
                body: JSON.stringify({
                    pokladna_id: Number(pokladnaId),
                    zamestnanec_id: Number(zamestnanecId),
                }),
            });
            if (!r.ok) throw new Error(await r.text());
            onSaved?.();
        } catch (e) { alert('Otevření selhalo: ' + e.message); }
        setSubmitting(false);
    };

    return (
        <SidePanel open={true} onClose={onClose} title="Otevřít flek" isDark={isDark} isMobile={isMobile} width={420} modal={true}
            footer={
                <div className="flex gap-2">
                    <button onClick={onClose} className="px-4 py-2 rounded-lg text-sm" style={{ color: 'var(--text-secondary)' }}>Zrušit</button>
                    <button onClick={handleSubmit} disabled={submitting} className="flex-1 py-2 rounded-lg text-sm font-medium text-white" style={{ background: '#3B82F6', opacity: submitting ? 0.5 : 1 }}>
                        {submitting ? 'Otevírám…' : 'Otevřít'}
                    </button>
                </div>
            }
        >
            <div className="p-5 space-y-3 text-sm" style={{ color: 'var(--text-primary)' }}>
                <p className="text-xs" style={{ color: 'var(--text-tertiary)' }}>
                    Krok A: ruční otevření smeny. V Kroku B se přidělí automaticky při klok-in.
                </p>
                <div>
                    <label className="text-xs font-medium mb-1 block" style={{ color: 'var(--text-secondary)' }}>Flek</label>
                    <Dropdown value={pokladnaId} onChange={v => setPokladnaId(v)}
                        options={[{ value: '', label: '— vyber —' }, ...fleky.map(f => ({ value: f.id, label: f.nazev }))]}
                        placeholder="— vyber —" isDark={isDark} accent="#3B82F6" height={38} />
                </div>
                <div>
                    <label className="text-xs font-medium mb-1 block" style={{ color: 'var(--text-secondary)' }}>Zaměstnanec</label>
                    <Dropdown value={zamestnanecId} onChange={v => setZamestnanecId(v)}
                        options={[{ value: '', label: '— vyber —' }, ...zamestnanci.map(z => ({ value: z.id, label: `${z.jmeno} ${z.prijmeni}` }))]}
                        placeholder="— vyber —" isDark={isDark} accent="#3B82F6" height={38} />
                </div>
            </div>
        </SidePanel>
    );
}
